import { render } from "./About.vue?vue&type=template&id=5b7a92bd&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=5b7a92bd&scoped=true&lang=css"

import exportComponent from "/builds/alex-yonge-photography/alex-yonge-photographs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7a92bd"]])

export default __exports__